import { ApiTransport, omitApiTransportProps } from '@infotech/lib-api-middleware'
import {
  compose,
  withPropsOnChange,
  branch,
} from 'recompose'
import {
  ESUZ_USERS_SCHEMA_NAME,
  esuzUsersApiActionsGenerator,
  esuzUsersSelector,
} from 'api/esuzUsers'


const withUserByUserId = branch(
  ({ userId }) => userId,
  compose(
    withPropsOnChange([`userId`], ({ userId }) => ({
      entity      : ESUZ_USERS_SCHEMA_NAME,
      apiAction   : esuzUsersApiActionsGenerator.fetch,
      dataSelector: esuzUsersSelector,
      query       : userId,
      dataPropName: `esuzUser`,
    })),
    ApiTransport,
    omitApiTransportProps,
  ),
)

export default withUserByUserId
